module.exports = __webpack_public_path__ + "static/media/ic_verify_otp_fisdom.fab17a05.svg";